import OurPressDataType from 'src/types/OurPressDataType'

export const OUR_PRESS_DATA: {
  ko: OurPressDataType[]
  en: OurPressDataType[]
} = {
  ko: [
    {
      headLine: '온라인 코딩 교육 \'코드잇\', 100억 시리즈 B 투자 유치',
      press: '한국경제TV',
      onClick: () => window.open('https://www.wowtv.co.kr/NewsCenter/News/Read?articleId=A202111180215')
    }, {
      headLine: '에듀테크 스타트업, 코드잇 시리즈 B 투자 유치',
      press: '아시아경제',
      onClick: () => window.open('https://cm.asiae.co.kr/article/2021111809165396826')
    }, {
      headLine: '코드잇, 대학 제휴 코딩 교육 프로그램 운영',
      press: '인터뷰365',
      onClick: () => window.open('https://www.interview365.com/news/articleView.html?idxno=100104')
    }, {
      headLine: '실습 환경 갖춘 온라인 코딩 교육 \'코드잇\', B2B 고객사 수 늘어',
      press: '시민일보',
      onClick: () => window.open('https://www.siminilbo.co.kr/news/newsview.php?ncode=1160295848070198')
    }, {
      headLine: '에듀테크 스타트업 \'코드잇\', K-비대면 바우처 통해 1500여 개 중소기업 지원',
      press: 'IT비즈뉴스',
      onClick: () => window.open('http://www.it-b.co.kr/news/articleView.html?idxno=54825')
    }, {
      headLine: '코드잇 공동 대표가 1시간짜리 강의를 절대 안 만드는 이유',
      press: '아웃스탠딩',
      onClick: () => window.open('https://outstanding.kr/codeit20211221')
    },
    {
      headLine: '코드잇, 2021 중기부 \'아기유니콘\' 선정 기념 프로모션 진행',
      press: 'IT비즈뉴스',
      onClick: () => window.open('https://www.itbiznews.com/news/articleView.html?idxno=40655')
    },
    {
      headLine: '\'아시아 30세 이하 리더\' 꼽힌 청년 창업가 3인 "나의 플랜B는 젊음"',
      press: '매일경제',
      onClick: () => window.open('https://www.mk.co.kr/news/business/view/2021/05/463388/')
    },
    {
      headLine: '코드잇, 전 직원 대상 코로나19 \'백신 휴가\' 도입... 최대 나흘 쉰다',
      press: '시민일보',
      onClick: () => window.open('https://www.siminilbo.co.kr/news/newsview.php?ncode=1065600611484809')
    },
    {
      headLine: '코드잇, 국내 코딩 교육 기업 최초로 멤버십 1만 명 돌파',
      press: '파이낸셜뉴스',
      onClick: () => window.open('https://www.fnnews.com/news/202104021713387545')
    },
    {
      headLine: '[#Let\'s 스타트업] 코드잇, 2030 열광하는 인터랙티브 코딩 교육 플랫폼',
      press: '매일경제',
      onClick: () => window.open('https://www.mk.co.kr/news/it/view/2020/04/416448/')
    },
    {
      headLine: '코딩교육 서비스 \'코드잇\', 시리즈A 40억 유치',
      press: '더벨',
      onClick: () => window.open('http://www.thebell.co.kr/free/content/ArticleView.asp?key=202003311805559280107176&svccode=00&page=1&sort=thebell_check_time')
    },
    {
      headLine: '교육의 혁신을 일으키고 있는 \'코드잇\'은 누가 만들었을까?',
      press: '매거진 한경',
      onClick: () => window.open('https://magazine.hankyung.com/job-joy/article/202102165302d')
    },
    {
      headLine: '5분 강의로 코딩 교육의 혁신을 만들다, 코드잇 강영훈 대표',
      press: '아시아뉴스통신',
      onClick: () => window.open('https://www.anewsa.com/detail.php?number=2014559&thread=19')
    },
  ],
  en: [
    {
      headLine: 'Codeit Launches Promotion to Celebrate 2021 Baby Unicorn Startup Nomination',
      press: 'IT Biz News',
      onClick: () => window.open('https://www.itbiznews.com/news/articleView.html?idxno=40655')
    },
    {
      headLine: 'Forbes 30 under 30 Asia: Stories of Passion and Youth',
      press: 'Maekyung Media',
      onClick: () => window.open('https://www.mk.co.kr/news/business/view/2021/05/463388/')
    },
    {
      headLine: 'Codeit implements "vaccine holiday": employees receive up to 4 days off ',
      press: 'Siminilbo',
      onClick: () => window.open('https://www.siminilbo.co.kr/news/newsview.php?ncode=1065600611484809')
    },
    {
      headLine: 'Codeit is first in the South Korean programming edtech industry to reach ten thousand users',
      press: 'FNnews',
      onClick: () => window.open('https://www.fnnews.com/news/202104021713387545')
    },
    {
      headLine: 'New age coding platform for millenials: Codeit',
      press: 'Maekyung Media',
      onClick: () => window.open('https://www.mk.co.kr/news/it/view/2020/04/416448/')
    },
    {
      headLine: 'Programming edtech company Codeit acquires $4M Series A funding',
      press: 'The Bell',
      onClick: () => window.open('http://www.thebell.co.kr/free/content/ArticleView.asp?key=202003311805559280107176&svccode=00&page=1&sort=thebell_check_time')
    },
    {
      headLine: 'The story of how one idea revolutionized the South Korean education industry',
      press: 'Magazine Hankyung',
      onClick: () => window.open('https://magazine.hankyung.com/job-joy/article/202102165302d')
    },
    {
      headLine: 'Young Kang, the visionary behind Codeit\'s bite-sized education model',
      press: 'Asia News Agency',
      onClick: () => window.open('https://www.anewsa.com/detail.php?number=2014559&thread=19')
    },
  ]
}

